export default __webpack_public_path__ + "static/media/sidenav-bg.93f8b7f9.jpg";